export const WITHOUT_INPUT_ID = "WITHOUT_INPUT_ID";
export const AYLWAYS_SHOW_OUTPUT = "AYLWAYS_SHOW_OUTPUT";
